import * as React from "react";

import { LEFT, RIGHT } from "icons";
import { addDays, format, isAfter, subDays, parseISO } from "date-fns";
import { formatDateForAPI } from "utils/utils";

import { Button } from "ui/components/button";
import Icon from "./icon";
import { cn } from "utils";
import { useNavigate } from "react-router-dom";

export function DatePicker({ day, className }) {
  const isFutureDate = (d) => {
    if (!d) return false;
    const dateStr = typeof d === "string" ? d : formatDateForAPI(d);
    const todayStr = formatDateForAPI(new Date());
    return dateStr > todayStr;
  };

  const navigate = useNavigate();
  React.useEffect(() => {
    if (day && isFutureDate(day)) {
      navigate(-1);
    }
  }, [day, navigate]);

  function handleSetDate(date) {
    navigate({ search: `?date=${formatDateForAPI(date)}` });
  }

  function moveToNextDate() {
    if (!day) return;
    const nextDay = addDays(parseISO(day), 1);
    handleSetDate(nextDay);
  }

  function moveToPreviousDate() {
    if (!day) return;
    const prevDay = subDays(parseISO(day), 1);
    handleSetDate(prevDay);
  }

  const isNextDayFuture = day ? isFutureDate(addDays(parseISO(day), 1)) : false;

  let dateStr = "";
  if (day) {
    try {
      const d = parseISO(day);
      if (!isNaN(d.getTime())) {
        dateStr = format(d, "yyyy-MM-dd");
      }
    } catch (e) {
      // ignore
    }
  }

  return (
    <div className={cn("flex gap-2", className)}>
      <Button variant="outline" onClick={moveToPreviousDate}>
        <Icon icon={LEFT} />
      </Button>
      <input
        type="date"
        className={cn(
          "flex h-9 w-36 rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          "relative [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-3 [&::-webkit-calendar-picker-indicator]:cursor-pointer",
          !day && "text-muted-foreground"
        )}
        value={dateStr}
        max={format(new Date(), "yyyy-MM-dd")}
        onChange={(e) => {
          const val = e.target.value;
          if (val) {
            const [year, month, date] = val.split("-");
            handleSetDate(new Date(year, month - 1, date));
          }
        }}
      />
      <Button
        variant="outline"
        disabled={isNextDayFuture}
        onClick={moveToNextDate}
      >
        <Icon icon={RIGHT} />
      </Button>
    </div>
  );
}
